import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _createSuper from "@babel/runtime/helpers/createSuper";
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Button from '@nerdwallet/react-button';
import { setTrk, TrkTag } from '@nerdwallet/nw-client-lib/trk-helper';
var COMPARE_PAGE_URL = '/compare/credit-cards';

var CompareLink = /*#__PURE__*/function (_React$Component) {
  _inherits(CompareLink, _React$Component);

  var _super = _createSuper(CompareLink);

  function CompareLink(props) {
    var _this;

    _classCallCheck(this, CompareLink);

    _this = _super.call(this, props);
    _this.state = {
      isAnimating: false
    };
    _this.setAnimatingStatus = _this.setAnimatingStatus.bind(_assertThisInitialized(_this));
    return _this;
  } // eslint-disable-next-line react/no-deprecated -- directive added automatically by Shepherd migration


  _createClass(CompareLink, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      var ANIMATION_DURATION_MS = 500;
      var currentCount = this.props.numCardsToCompare;
      var nextCount = nextProps.numCardsToCompare;

      if (currentCount && nextCount && nextCount !== currentCount) {
        if (this.animationTimeout) {
          clearTimeout(this.animationTimeout);
        }

        this.setState({
          isAnimating: true
        });
        this.animationTimeout = setTimeout(this.setAnimatingStatus.bind(this, false), ANIMATION_DURATION_MS);
      }
    }
  }, {
    key: "setAnimatingStatus",
    value: function setAnimatingStatus() {
      var isAnimating = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      this.setState({
        isAnimating: isAnimating
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          isActive = _this$props.isActive,
          numCardsToCompare = _this$props.numCardsToCompare,
          taxonomy = _this$props.taxonomy,
          mobileCtaText = _this$props.mobileCtaText,
          ctaText = _this$props.ctaText;
      var linkClasses = classNames('compare-link', 'ripply', {
        active: isActive,
        animate: this.state.isAnimating,
        responsive: !!mobileCtaText
      });
      var countClasses = classNames('count', 'rel', this.props.buttonClassName, {
        animate: this.state.isAnimating
      });
      var compareLink;

      if (this.props.overrideCTA) {
        compareLink = this.props.overrideCTA;
      } else {
        var compareAnchor = setTrk({
          url: COMPARE_PAGE_URL,
          taxonomy: taxonomy,
          params: _defineProperty({}, TrkTag.location, 'cc-compare-bar-compare-button')
        });
        compareLink = /*#__PURE__*/React.createElement(Button, {
          primary: true,
          href: compareAnchor,
          className: linkClasses
        }, /*#__PURE__*/React.createElement("div", {
          className: "compare-link__content"
        }, mobileCtaText && /*#__PURE__*/React.createElement("span", {
          className: "rel rel--mobile"
        }, mobileCtaText), /*#__PURE__*/React.createElement("span", {
          className: "rel rel--desktop"
        }, ctaText), /*#__PURE__*/React.createElement("span", {
          className: countClasses
        }, /*#__PURE__*/React.createElement("span", null, numCardsToCompare))));
      }

      return compareLink;
    }
  }]);

  return CompareLink;
}(React.Component); // eslint-disable-next-line react/static-property-placement -- directive added automatically by Shepherd migration


CompareLink.propTypes = {
  // eslint-disable-next-line react/require-default-props
  numCardsToCompare: PropTypes.number,
  // eslint-disable-next-line react/require-default-props
  isActive: PropTypes.bool,
  // eslint-disable-next-line react/require-default-props
  buttonClassName: PropTypes.string,
  // eslint-disable-next-line react/require-default-props
  overrideCTA: PropTypes.node,
  ctaText: PropTypes.string,
  mobileCtaText: PropTypes.string,
  taxonomy: PropTypes.shape({})
}; // eslint-disable-next-line react/static-property-placement -- directive added automatically by Shepherd migration

CompareLink.defaultProps = {
  ctaText: 'Compare Cards',
  mobileCtaText: null,
  taxonomy: {}
};
export default CompareLink;